{
  "CUSTOM_ROLE": {
    "HEADER": "Пользовательские роли",
    "LEARN_MORE": "Узнать больше о пользовательских ролях",
    "DESCRIPTION": "Пользовательские роли — это роли, созданные владельцем учетной записи или администратором. Эти роли могут быть назначены агентам для определения их доступа и прав доступа к аккаунту. Пользовательские роли могут быть созданы с определенными разрешениями и уровнями доступа в соответствии с требованиями организации.",
    "HEADER_BTN_TXT": "Добавить роль",
    "LOADING": "Загрузка пользовательских ролей...",
    "SEARCH_404": "Нет категорий, соответствующих запросу.",
    "PAYWALL": {
      "TITLE": "Обновитесь для создания пользовательских роли",
      "AVAILABLE_ON": "Функция пользовательских ролей доступна только в тарифных планах Business и Enterprise.",
      "UPGRADE_PROMPT": "Обновите ваш тарифный план, чтобы получить доступ к расширенным функциям, таким как управление командой, автоматизация, пользовательские атрибуты и другие.",
      "UPGRADE_NOW": "Обновить сейчас",
      "CANCEL_ANYTIME": "Вы можете изменить или отменить ваш тарифный план в любое время"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Функция пользовательских ролей доступна только в платных тарифных планах.",
      "UPGRADE_PROMPT": "Перейдите на платный тарифный план, чтобы получить доступ к расширенным функциям, таким как аудит журналов, пропускная способность агентов и другие.",
      "ASK_ADMIN": "Пожалуйста, обратитесь к вашему администратору для обновления."
    },
    "LIST": {
      "404": "В этом аккаунте нет пользовательских ролей.",
      "TITLE": "Управление ролями",
      "DESC": "Пользовательские роли — это роли, созданные владельцем учетной записи или администратором. Эти роли могут быть назначены агентам для определения их доступа и прав доступа к аккаунту. Пользовательские роли могут быть созданы с определенными разрешениями и уровнями доступа в соответствии с требованиями организации.",
      "TABLE_HEADER": {
        "NAME": "Имя",
        "DESCRIPTION": "Описание",
        "PERMISSIONS": "Права доступа",
        "USAGE_COUNT": "Используется",
        "ACTIONS": "Действия"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Управление всеми диалогами",
      "CONVERSATION_UNASSIGNED_MANAGE": "Управление неназначенными беседами и теми, которые им назначены",
      "CONVERSATION_PARTICIPATING_MANAGE": "Управление текущими беседами и теми, которые им назначены",
      "CONTACT_MANAGE": "Управление контактами",
      "ACCESS_ALL_REPORTS": "Просмотр всех отчетов",
      "KNOWLEDGE_BASE_MANAGE": "Управление базой знаний",
      "DATA_ASSISTANT_MANAGE": "Управление дата-ассистентом",
      "CALL_RECORDING_ACCESS": "Доступ ко всем записям звонков"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Имя",
        "PLACEHOLDER": "Пожалуйста, введите время.",
        "ERROR": "Необходимо указать имя."
      },
      "DESCRIPTION": {
        "LABEL": "Описание",
        "PLACEHOLDER": "Пожалуйста, введите описание.",
        "ERROR": "Необходимо описание."
      },
      "PERMISSIONS": {
        "LABEL": "Права доступа",
        "ERROR": "Необходимы права доступа."
      },
      "CANCEL_BUTTON_TEXT": "Отменить",
      "API": {
        "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
      }
    },
    "ADD": {
      "TITLE": "Добавить роль",
      "DESC": " Пользовательские роли позволяют создавать роли с определенными разрешениями и уровнями доступа в соответствии с требованиями организации.",
      "SUBMIT": "Отправить",
      "API": {
        "SUCCESS_MESSAGE": "Пользовательская роль успешно добавлена."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Редактировать",
      "TITLE": "Изменить пользовательскую роль",
      "DESC": " Пользовательские роли позволяют создавать роли с определенными разрешениями и уровнями доступа в соответствии с требованиями организации.",
      "SUBMIT": "Обновить",
      "API": {
        "SUCCESS_MESSAGE": "Пользовательская роль успешно обновлена."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Пользовательская роль успешно удалена.",
        "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
      },
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы точно хотите удалить ",
        "YES": "Да, удалить ",
        "NO": "Нет, не удалять "
      }
    }
  }
}
